// extracted by mini-css-extract-plugin
export var categoryIcon = "_dt-5";
export var connectorContainer = "_dt-1";
export var connectorLine = "_dt-0";
export var minHeight0 = "_dt-6";
export var relativeUnitValueSelector = "_dt-2";
export var trifoldSelectorBody = "_dt-4";
export var trifoldSelectorList = "_dt-3";